<template>
  <div class="home">
    <Nav/>
    <div class="home-container">
      <router-view/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'Home',
  components: {
    Nav,
    Footer
  }
}
</script>
<style scoped>
.home {
  background: #e5e5e5;
}
.home{
  background: #e5e5e5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.home-container{
  flex: 1;
  margin: 0 auto;
  width: 100%;
  max-width: 1180px;
  padding: 24px 0;
}
</style>
